import { StyleSheet } from 'aphrodite/no-important';

export const getLinksStyle = (
  activeStateColor: string,
  hoverStateColor: string,
  idleColor: string,
  isActive: boolean,
) => {
  return StyleSheet.create({
    link: {
      color: isActive ? activeStateColor : idleColor,
      textDecoration: 'none',
      ':hover': {
        color: hoverStateColor,
      },
    },
  });
};
